import { render, staticRenderFns } from "./Deal.vue?vue&type=template&id=352c1e4f&scoped=true&"
import script from "./Deal.vue?vue&type=script&lang=js&"
export * from "./Deal.vue?vue&type=script&lang=js&"
import style0 from "./Deal.vue?vue&type=style&index=0&id=352c1e4f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352c1e4f",
  null
  
)

export default component.exports